<section class="agpr-deliveryScheduleInput" *ngIf="value" role="radiogroup" [attr.aria-labelledby]="id + '-label'">
  <header *ngIf="header" class="u-srOnly">
    <label [id]="id + '-label'">
      {{ header | localize }}
    </label>
  </header>
  <ng-container>
    <div
      class="agpr-deliveryScheduleInput-schedulingTypes"
      role="radiogroup"
      [attr.aria-label]="'Amplify.wire.schedulingOptions' | localize"
    >
      <div
        class="agpr-deliveryScheduleInput-schedulingType"
        role="group"
        [attr.aria-label]="immediateOptionLabel | localize"
        [attr.aria-describedby]="id + '-schedulingDisclaimer-immediate'">
        <agpr-radio
          [id]="id + '-immediateRadioButton'"
          name="schedule-urgency-{{id}}"
          [value]="scheduleTypes.immediate"
          [label]="immediateOptionLabel"
          [hiddenLabel]="immediateOptionLabel"
          [disabled]="disabled"
          [(ngModel)]="value.scheduleType"
          (onClick)="scheduleTypeChanged(scheduleTypes.immediate)"
        ></agpr-radio>
        <div
          *ngIf="value.scheduleType === scheduleTypes.immediate && !!disclaimer"
          [id]="id + '-schedulingDisclaimer-immediate'"
          class="agpr-deliveryScheduleInput-disclaimer"
          @slideInOut
        >
          <ng-container *ngTemplateOutlet="disclaimer;"></ng-container>
        </div>
      </div>
      <div
        class="agpr-deliveryScheduleInput-schedulingType"
        role="group"
        [attr.aria-label]="futureOptionLabel | localize"
        [attr.aria-describedby]="'scheduled-delivery-date-errors-' + id + ' ' + id + '-schedulingDisclaimer-future'"
      >
        <agpr-radio
          [id]="id + '-futureRadioButton'"
          name="schedule-urgency-{{id}}"
          [value]="scheduleTypes.scheduledDate"
          [label]="futureOptionLabel"
          [hiddenLabel]="futureOptionLabel"
          [disabled]="disabled"
          [(ngModel)]="value.scheduleType"
          (onClick)="scheduleTypeChanged(scheduleTypes.scheduledDate)"
        ></agpr-radio>
        <div
          class="agpr-deliveryScheduleInput-futureDateSelector"
          *ngIf = "value.scheduleType === scheduleTypes.scheduledDate"
          @slideInOut
        >
          <div
            class="ui-fluid"
          >
            <div class="agpr-inputOverlay">
              <span [id]="id + '_dateLabel'" class="u-srOnly">{{ 'date' | localize }}. {{ 'dateFormat' | localize }}</span>
              <agpr-date-picker
                [id]="id + '_deliveryScheduleInput_datePicker'"
                [minDate]="minDate"
                [readonlyInput]="disabled"
                [ariaLabelledBy]="id + '_dateLabel'"
                [(ngModel)]="calendarDate"
                (blur)="debouncedUpdateDeliveryDate()"
                (select)="debouncedUpdateDeliveryDate()"
              ></agpr-date-picker>
            </div>
          </div>
          <div>
            <ng-container *ngIf="time">
              <agpr-time-picker
                [id]="id + '-updateDeliveryDate'"
                hourDescribedBy="scheduled-delivery-date-errors-{{id}}"
                minuteDescribedBy="scheduled-delivery-date-errors-{{id}}"
                [infoIconStyleClass]="infoIconStyleClass"
                [infoTooltipStyleClass]="infoTooltipStyleClass"
                [disabled]="disabled"
                [(ngModel)]="time"
                (changeTimeZone)="scheduleModified()"
                (changeHour)="scheduleModified()"
                (changeMinute)="scheduleModified()"
                (changeMeridian)="scheduleModified()"
                [header]="'time' | localize"
              ></agpr-time-picker>
              <ul
                *ngIf="!disabled"
                id="scheduled-delivery-date-errors-{{id}}"
                class="agpr-deliveryScheduleInput-validationMessages"
              >
                <li *ngFor="let error of errors">
                  <agpr-form-message>
                    {{ error.summary | localize }}
                  </agpr-form-message>
                </li>
              </ul>
            </ng-container>
          </div>
          <div
            *ngIf="value.scheduleType === scheduleTypes.scheduledDate && !!disclaimer"
            [id]="id + '-schedulingDisclaimer-future'"
            class="agpr-deliveryScheduleInput-disclaimer"
            @slideInOut
          >
            <ng-container *ngTemplateOutlet="disclaimer;"></ng-container>
          </div>
        </div>
      </div>
    </div>
    <div
      class="agpr-deliveryScheduleInput-schedulingType"
      *ngIf="showRecurring"
      role="radiogroup"
      [attr.aria-label]="recurringOptionLabel | localize"
      @slideInOut
      [attr.aria-describedby]="'recurring-delivery-date-errors-' + id"
    >
      <agpr-radio
        [id]="id + '-recurringRadioButton'"
        name="schedule-urgency-{{id}}"
        [value]="scheduleTypes.recurring"
        [label]="recurringOptionLabel"
        [hiddenLabel]="recurringOptionLabel"
        [disabled]="disabled"
        [(ngModel)]="value.scheduleType"
        (onClick)="scheduleTypeChanged(scheduleTypes.recurring)"
      ></agpr-radio>
      <div
        class="agpr-deliveryScheduleInput-recurringPatternSelector"
      >
<!--
      [ngClass]="{
        'agpr-deliveryScheduleInput-recurringPatternSelector--active': selectedSchedulingType === deliverySchedulingTypes.recurring,
        'agpr-deliveryScheduleInput-recurringPatternSelector--inactive': selectedSchedulingType !== deliverySchedulingTypes.recurring
      }" -->

        <agpr-radio
          name="recurring-schedule-{{id}}"
          [id]="id + '-recurringDailyRadioButton'"
          [value]="deliveryRecurrenceFrequencyEnum.daily"
          label="DeliveryScheduler.input.daily"
          hiddenLabel="DeliveryScheduler.input.daily"
          [(ngModel)]="recurringModel.frequencyType"
          (onClick)="updateRecurringType(deliveryRecurrenceFrequencyEnum.daily)"
        >
        </agpr-radio>
        <div
          class="agpr-deliveryScheduleInput-recurringPatternSelectorDetails"
          *ngIf="recurringModel.frequencyType === deliveryRecurrenceFrequencyEnum.daily"
        >
          <agpr-multi-time-picker
            [id]="id + '-recurringDailyTimes'"
            hourDescribedBy="recurring-delivery-date-errors-{{id}}"
            minuteDescribedBy="recurring-delivery-date-errors-{{id}}"
            [infoIconStyleClass]="infoIconStyleClass"
            [infoTooltipStyleClass]="infoTooltipStyleClass"
            [(ngModel)]="recurringMultiTimes"
            (ngModelChange)="updateRecurringPattern()"
            [showTimeZoneSelector]="true"
          >
          </agpr-multi-time-picker>
        </div>

        <agpr-radio
          name="recurring-schedule-{{id}}"
          [id]="id + '-recurringWeeklyRadioButton'"
          [value]="deliveryRecurrenceFrequencyEnum.weekly"
          label="DeliveryScheduler.input.weekly"
          hiddenLabel="DeliveryScheduler.input.weekly"
          [(ngModel)]="recurringModel.frequencyType"
          (onClick)="updateRecurringType(deliveryRecurrenceFrequencyEnum.weekly)"
        >
        </agpr-radio>
        <div
          class="agpr-deliveryScheduleInput-recurringPatternSelectorDetails"
          *ngIf="recurringModel.frequencyType === deliveryRecurrenceFrequencyEnum.weekly"
        >

          <p-multiSelect
            [inputId]="id + '-recurringWeekly-weekdaySelector'"
            [(ngModel)]="recurringModel.frequencyValues"
            (onChange)="updateRecurringPattern()"
            [options]="daysOfTheWeek"
            [filter]="false"
          >
          </p-multiSelect>
          <agpr-time-picker
            [id]="id + '-recurringWeekly-timeSelector'"
            hourDescribedBy="recurring-delivery-date-errors-{{id}}"
            minuteDescribedBy="recurring-delivery-date-errors-{{id}}"
            [infoIconStyleClass]="infoIconStyleClass"
            [infoTooltipStyleClass]="infoTooltipStyleClass"
            [(ngModel)]="recurringTime"
            [showTimeZoneSelector]="true"
            (changeTimeZone)="updateRecurringPattern()"
            (changeHour)="updateRecurringPattern()"
            (changeMinute)="updateRecurringPattern()"
            (changeMeridian)="updateRecurringPattern()"
          ></agpr-time-picker>
        </div>

        <agpr-radio
          name="recurring-schedule-{{id}}"
          [id]="id + '-recurringMonthlyRadioButton'"
          [value]="deliveryRecurrenceFrequencyEnum.monthly"
          label="DeliveryScheduler.input.monthly"
          hiddenLabel="DeliveryScheduler.input.monthly"
          [(ngModel)]="recurringModel.frequencyType"
          (onClick)="updateRecurringType(deliveryRecurrenceFrequencyEnum.monthly)"
        >
        </agpr-radio>
        <div
          class="agpr-deliveryScheduleInput-recurringPatternSelectorDetails"
          *ngIf="recurringModel.frequencyType === deliveryRecurrenceFrequencyEnum.monthly"
        >
          <p-multiSelect
            [id]="id + '-recurringMonthly-dateSelector'"
            [(ngModel)]="recurringModel.frequencyValues"
            (onChange)="updateRecurringPattern()"
            [options]="daysOfTheMonthOptions"
            [filter]="false"
          ></p-multiSelect>

          <agpr-time-picker
            [id]="id + '-recurringMonthly-timeSelector'"
            hourDescribedBy="recurring-delivery-date-errors-{{id}}"
            minuteDescribedBy="recurring-delivery-date-errors-{{id}}"
            [infoIconStyleClass]="infoIconStyleClass"
            [infoTooltipStyleClass]="infoTooltipStyleClass"
            [(ngModel)]="recurringTime"
            [showTimeZoneSelector]="true"
            (changeTimeZone)="updateRecurringPattern()"
            (changeHour)="updateRecurringPattern()"
            (changeMinute)="updateRecurringPattern()"
            (changeMeridian)="updateRecurringPattern()"
          ></agpr-time-picker>
        </div>
        <ul id="recurring-delivery-date-errors-{{id}}">
          <li *ngFor="let error of errors">
            <agpr-form-message>
              {{ error.summary | localize }}
            </agpr-form-message>
          </li>
        </ul>
      </div>
    </div>
  </ng-container>
</section>
